import { render, staticRenderFns } from "./CXP.vue?vue&type=template&id=0d61a763&"
import script from "./CXP.vue?vue&type=script&lang=js&"
export * from "./CXP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports